// src/components/ArtworkList.js
import React from 'react';
import { Box } from '@mui/material';
import ArtworkCard from './ArtworkCard';

export default function ArtworkList({ artworks, userRole, containerSx = {}, artworkCardSx = {} }) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '24px', // consistent spacing between cards
        justifyContent: 'center', // centers grid within container
        padding: '16px', // optional, adds space around the grid
        ...containerSx,
      }}
    >
      {artworks.map((artwork) => (
        <ArtworkCard key={artwork.id} artwork={artwork} userRole={userRole} cardSx={artworkCardSx} />
      ))}
    </Box>
  );
}
